import authoringToolsConfig from "./authoringToolsConfig";
import { glueParamsToUrl } from "../../../../commonjs/helpers";

const selectPageInParentWindow = function (payload) {
  let slug = payload.slug || payload.page || "";
  let type = payload.type || 'page';

  let params = copyJson(payload);
  delete params['slug'];
  delete params['page'];
  delete params['type'];
  delete params['replaceState'];
  params["_referrer"] = "admin";
  let authoringLink = authoringToolsConfig[type].authoringLink.replace('{slug}', slug);
  authoringLink = glueParamsToUrl(authoringLink ,params);

  if (!payload.replaceState) {
      window.top.History.pushState({ url: authoringLink, pageDataPayload: payload}, document.title, authoringLink.replace("&_referrer=admin","").replace("?_referrer=admin",""));
  } else {
      window.top.History.replaceState({url:authoringLink , pageDataPayload: payload}, document.title, authoringLink.replace("&_referrer=admin","").replace("?_referrer=admin",""));
  }
}

export { selectPageInParentWindow };
